module.exports = __webpack_public_path__ + "img/evolution-emploi.b2bd8312.png";